import { render } from "./app.vue?vue&type=template&id=bd0e10ca"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominiksasko/Desktop/Projects/Piano-Chords-AI-Recognition/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__